import m from "./highrise977.mjs";
import u from "./highrise949.mjs";
function f(x) {
  const {
    primaryColor: r,
    textColor2: o,
    borderColor: h,
    lineHeight: e,
    fontSize: t,
    borderRadiusSmall: c,
    dividerColor: p,
    fontWeightStrong: s,
    textColor1: l,
    textColor3: i,
    infoColor: C,
    warningColor: a,
    errorColor: n,
    successColor: d,
    codeColor: g
  } = x;
  return Object.assign(Object.assign({}, m), {
    aTextColor: r,
    blockquoteTextColor: o,
    blockquotePrefixColor: h,
    blockquoteLineHeight: e,
    blockquoteFontSize: t,
    codeBorderRadius: c,
    liTextColor: o,
    liLineHeight: e,
    liFontSize: t,
    hrColor: p,
    headerFontWeight: s,
    headerTextColor: l,
    pTextColor: o,
    pTextColor1Depth: l,
    pTextColor2Depth: o,
    pTextColor3Depth: i,
    pLineHeight: e,
    pFontSize: t,
    headerBarColor: r,
    headerBarColorPrimary: r,
    headerBarColorInfo: C,
    headerBarColorError: n,
    headerBarColorWarning: a,
    headerBarColorSuccess: d,
    textColor: o,
    textColor1Depth: l,
    textColor2Depth: o,
    textColor3Depth: i,
    textColorPrimary: r,
    textColorInfo: C,
    textColorSuccess: d,
    textColorWarning: a,
    textColorError: n,
    codeTextColor: o,
    codeColor: g,
    codeBorder: "1px solid #0000"
  });
}
const B = {
  common: u,
  self: f
};
export {
  B as default,
  f as self
};
